
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";

/**
 * Envia os dados do formulário para o backend processar o envio do e-mail.
 * Isso mantém as credenciais seguras no servidor.
 */
export const sendWholesaleEmail = async (formData) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/send-email`, formData);
    return { success: true, message: response.data.message };
  } catch (error) {
    console.error("Erro ao enviar e-mail:", error);
    throw error;
  }
};
